import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

// Inject admin token if present
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("aba_admin_token");
    if (token && config.url?.startsWith("/admin")) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1566474949309-1ecedbf7382e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxvbGQlMjBzdG9uZSUyMHdhbGwlMjBtYXNvbnJ5fGVufDB8fHx8MTc3NzY1NjgzNXww&ixlib=rb-4.1.0&q=85",
    about: "https://images.unsplash.com/photo-1594695422351-cdfe65ac915b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxtYXNvbnJ5JTIwYXJ0aXNhbiUyMHJlc3RvcmF0aW9ufGVufDB8fHx8MTc3NzY1Njg1Nnww&ixlib=rb-4.1.0&q=85",
    gallery1: "https://images.unsplash.com/photo-1768573490645-8d7798624956?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxvbGQlMjBzdG9uZSUyMHdhbGwlMjBtYXNvbnJ5fGVufDB8fHx8MTc3NzY1NjgzNXww&ixlib=rb-4.1.0&q=85",
    gallery2: "https://images.unsplash.com/photo-1772974566756-c195e0d015b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHxvbGQlMjBzdG9uZSUyMHdhbGwlMjBtYXNvbnJ5fGVufDB8fHx8MTc3NzY1NjgzNXww&ixlib=rb-4.1.0&q=85",
    training: "https://images.unsplash.com/photo-1672954766589-49f0dd0e106f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHx0cmFpbmluZyUyMHdvcmtzaG9wJTIwY29uc3RydWN0aW9ufGVufDB8fHx8MTc3NzY1Njg1NXww&ixlib=rb-4.1.0&q=85",
    painting: "https://images.unsplash.com/photo-1615873968403-89e068629265?crop=entropy&cs=srgb&fm=jpg&w=1600&q=85",
    texture: "https://images.unsplash.com/photo-1621327708553-f6d70636f961?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwxfHxsaW1lJTIwcGxhc3RlciUyMHdhbGwlMjB0ZXh0dXJlfGVufDB8fHx8MTc3NzY1Njg1Nnww&ixlib=rb-4.1.0&q=85",
};

export const COMPANY = {
    name: "Atelier du Bâti Ancien",
    tagline: "Diagnostic, restauration et formation",
    phone: "06 64 20 81 34",
    phoneRaw: "+33664208134",
    email: "lepeintre.artisan@gmail.com",
    address: "2 rue des Sablons, 28350 Saint-Lubin-des-Joncherets",
    zone: "Eure-et-Loir, Île-de-France et régions limitrophes",
};
